import { render, staticRenderFns } from "./AutoSelectedPhotos.vue?vue&type=template&id=162cc441&"
import script from "./AutoSelectedPhotos.vue?vue&type=script&lang=js&"
export * from "./AutoSelectedPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports